import { render } from "./team-monthly.vue?vue&type=template&id=63036d5b&scoped=true&ts=true"
import script from "./team-monthly.vue?vue&type=script&lang=ts"
export * from "./team-monthly.vue?vue&type=script&lang=ts"

import "./team-monthly.vue?vue&type=style&index=0&id=63036d5b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63036d5b"]])

export default __exports__